/**
 * Onda 5 (AN-11 §2.2–2.3): oportunidades passa a recusar reserva de produto que o catálogo
 * já marcou como inativo/removido (projeção `produto-projetado`), mesmo que o seletor ainda o
 * mostre (lista carregada antes da inativação, ou chamada direta).
 *
 * - 422 `PRODUTO_INATIVO` — "Este produto não está disponível para novas reservas."
 * - 422 `PRODUTO_DESCONHECIDO` — só com o interruptor `recusar-desconhecido` ligado.
 *
 * Nada foi gravado nos dois casos; a tela mostra o texto no seletor e recarrega os ativos.
 */
export type CodigoErroProdutoReserva = 'PRODUTO_INATIVO' | 'PRODUTO_DESCONHECIDO'

export const MENSAGEM_ERRO_PRODUTO_RESERVA: Record<CodigoErroProdutoReserva, string> = {
  PRODUTO_INATIVO:
    'Este produto não está mais disponível para novas reservas. A lista foi atualizada — escolha outro produto. Nada foi criado.',
  PRODUTO_DESCONHECIDO:
    'Não foi possível confirmar este produto no catálogo agora. A lista foi atualizada — escolha o produto de novo ou tente em instantes. Nada foi criado.',
}

/** O código, quando o erro é uma recusa de produto da reserva; senão `undefined`. */
export const codigoErroProdutoReserva = (e: unknown): CodigoErroProdutoReserva | undefined => {
  const codigo = (e as { data?: { errorCode?: unknown } } | null)?.data?.errorCode
  return codigo === 'PRODUTO_INATIVO' || codigo === 'PRODUTO_DESCONHECIDO' ? codigo : undefined
}
